import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface AutoSaveContextValue {
  autoSaveEnabled: boolean;
  toggleAutoSave: () => void;
}

const AutoSaveContext = createContext<AutoSaveContextValue>({
  autoSaveEnabled: false,
  toggleAutoSave: () => {},
});

export function AutoSaveProvider({ children }: { children: ReactNode }) {
  const [autoSaveEnabled, setAutoSaveEnabled] = useState(false);
  const toggleAutoSave = useCallback(() => setAutoSaveEnabled((p) => !p), []);

  return (
    <AutoSaveContext.Provider value={{ autoSaveEnabled, toggleAutoSave }}>
      {children}
    </AutoSaveContext.Provider>
  );
}

export function useAutoSaveContext() {
  return useContext(AutoSaveContext);
}
